webpackJsonp([0],{

/***/ 117:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(118);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(79)("39f6d124", content, true, {});

/***/ }),

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(78)(true);
// imports


// module
exports.push([module.i, ".base[data-v-c9c19100]{max-width:1000px}.small-element[data-v-c9c19100]{max-width:100px}.calc-card[data-v-c9c19100]{margin:0 auto 12px}.result-container[data-v-c9c19100]{display:-webkit-box;display:-ms-flexbox;display:flex}.result-container .result-element[data-v-c9c19100]{width:150px;-ms-flex-negative:0;flex-shrink:0}.result-container .result-element[data-v-c9c19100]:first-child{margin-left:auto}.result-container .result-element[data-v-c9c19100]:last-child{margin-right:auto}.result-container .result-element span[data-v-c9c19100]{font-size:11px}", "", {"version":3,"sources":["/home/gitlab-runner/gitlab-runners/gitlab-ci-runner/builds/70a7f055/0/eagleeye/mybikesetup-web/mybikesetup/src/views/SpokeCalculator.vue"],"names":[],"mappings":"AACA,uBACE,gBAAkB,CACnB,AACD,gCACE,eAAiB,CAClB,AACD,4BACE,kBAAyB,CAC1B,AACD,mCACE,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACf,AACD,mDACE,YAAa,AACb,oBAAqB,AACjB,aAAe,CACpB,AACD,+DACE,gBAAkB,CACnB,AACD,8DACE,iBAAmB,CACpB,AACD,wDACE,cAAgB,CACjB","file":"SpokeCalculator.vue","sourcesContent":["\n.base[data-v-c9c19100] {\n  max-width: 1000px;\n}\n.small-element[data-v-c9c19100] {\n  max-width: 100px;\n}\n.calc-card[data-v-c9c19100] {\n  margin: 0 auto 12px auto;\n}\n.result-container[data-v-c9c19100] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.result-container .result-element[data-v-c9c19100] {\n  width: 150px;\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n}\n.result-container .result-element[data-v-c9c19100]:first-child {\n  margin-left: auto;\n}\n.result-container .result-element[data-v-c9c19100]:last-child {\n  margin-right: auto;\n}\n.result-container .result-element span[data-v-c9c19100] {\n  font-size: 11px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 119:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hub_display_vue__ = __webpack_require__(95);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_206a851d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hub_display_vue__ = __webpack_require__(122);
function injectStyle (ssrContext) {
  __webpack_require__(120)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-206a851d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hub_display_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_206a851d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hub_display_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(121);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(79)("38c740eb", content, true, {});

/***/ }),

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(78)(true);
// imports


// module
exports.push([module.i, "img[data-v-206a851d]{width:100%}ul[data-v-206a851d]{list-style:none;text-align:left}.front-hub[data-v-206a851d],.rear-hub[data-v-206a851d]{position:relative}.left-dia[data-v-206a851d]{position:absolute;top:35%;left:0}.right-dia[data-v-206a851d]{position:absolute;top:35%;right:0}.left2-center[data-v-206a851d]{position:absolute;left:44%;bottom:0}.right2-center[data-v-206a851d]{position:absolute;left:62%;bottom:0}.rear-hub .left2-center[data-v-206a851d]{left:40%}.rear-hub .right2-center[data-v-206a851d]{left:55%}", "", {"version":3,"sources":["/home/gitlab-runner/gitlab-runners/gitlab-ci-runner/builds/70a7f055/0/eagleeye/mybikesetup-web/mybikesetup/src/components/hub-display.vue"],"names":[],"mappings":"AACA,qBACE,UAAY,CACb,AACD,oBACE,gBAAiB,AACjB,eAAiB,CAClB,AACD,uDAEE,iBAAmB,CACpB,AACD,2BACE,kBAAmB,AACnB,QAAS,AACT,MAAQ,CACT,AACD,4BACE,kBAAmB,AACnB,QAAS,AACT,OAAS,CACV,AACD,+BACE,kBAAmB,AACnB,SAAU,AACV,QAAU,CACX,AACD,gCACE,kBAAmB,AACnB,SAAU,AACV,QAAU,CACX,AACD,yCACE,QAAU,CACX,AACD,0CACE,QAAU,CACX","file":"hub-display.vue","sourcesContent":["\nimg[data-v-206a851d] {\n  width: 100%;\n}\nul[data-v-206a851d] {\n  list-style: none;\n  text-align: left;\n}\n.rear-hub[data-v-206a851d],\n.front-hub[data-v-206a851d] {\n  position: relative;\n}\n.left-dia[data-v-206a851d] {\n  position: absolute;\n  top: 35%;\n  left: 0;\n}\n.right-dia[data-v-206a851d] {\n  position: absolute;\n  top: 35%;\n  right: 0;\n}\n.left2-center[data-v-206a851d] {\n  position: absolute;\n  left: 44%;\n  bottom: 0;\n}\n.right2-center[data-v-206a851d] {\n  position: absolute;\n  left: 62%;\n  bottom: 0;\n}\n.rear-hub .left2-center[data-v-206a851d] {\n  left: 40%;\n}\n.rear-hub .right2-center[data-v-206a851d] {\n  left: 55%;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 122:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hub)?_c('div',[_c('h3',[_vm._v(" "+_vm._s(_vm.hub.manufacturer.name)+" - "+_vm._s(_vm.hub.model))]),_vm._v(" "),_c('ul',[(_vm.hub.axleWidth > 0)?_c('li',[_vm._v("Axle width: "+_vm._s(_vm.hub.axleWidth)+" mm")]):_vm._e(),_vm._v(" "),(_vm.hub.weight > 0)?_c('li',[_vm._v("Weight: "+_vm._s(_vm.hub.weight)+" g")]):_vm._e()]),_vm._v(" "),(!_vm.hub.rear)?_c('div',{staticClass:"front-hub"},[_c('img',{attrs:{"src":"/static/img/spoke/frontwheel.png"}}),_vm._v(" "),_c('div',{staticClass:"left-dia"},[_vm._v(_vm._s(_vm.hub.leftFlangeDiameter))]),_vm._v(" "),_c('div',{staticClass:"right-dia"},[_vm._v(_vm._s(_vm.hub.rightFlangeDiameter))]),_vm._v(" "),_c('div',{staticClass:"left2-center"},[_vm._v(_vm._s(_vm.hub.leftFlangeToCenter))]),_vm._v(" "),_c('div',{staticClass:"right2-center"},[_vm._v(_vm._s(_vm.hub.rightFlangeToCenter))])]):_c('div',{staticClass:"rear-hub"},[_c('img',{attrs:{"src":"/static/img/spoke/rearwheel.png"}}),_vm._v(" "),_c('div',{staticClass:"left-dia"},[_vm._v(_vm._s(_vm.hub.leftFlangeDiameter))]),_vm._v(" "),_c('div',{staticClass:"right-dia"},[_vm._v(_vm._s(_vm.hub.rightFlangeDiameter))]),_vm._v(" "),_c('div',{staticClass:"left2-center"},[_vm._v(_vm._s(_vm.hub.leftFlangeToCenter))]),_vm._v(" "),_c('div',{staticClass:"right2-center"},[_vm._v(_vm._s(_vm.hub.rightFlangeToCenter))])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 123:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_rim_display_vue__ = __webpack_require__(96);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30f378c9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_rim_display_vue__ = __webpack_require__(126);
function injectStyle (ssrContext) {
  __webpack_require__(124)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-30f378c9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_rim_display_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30f378c9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_rim_display_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(125);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(79)("27908c5a", content, true, {});

/***/ }),

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(78)(true);
// imports


// module
exports.push([module.i, "img[data-v-30f378c9]{width:100%}ul[data-v-30f378c9]{list-style:none;text-align:left}.front-hub[data-v-30f378c9],.rear-hub[data-v-30f378c9]{position:relative}.left-dia[data-v-30f378c9]{position:absolute;top:35%;left:0}.right-dia[data-v-30f378c9]{position:absolute;top:35%;right:0}.left2-center[data-v-30f378c9]{position:absolute;left:44%;bottom:0}.right2-center[data-v-30f378c9]{position:absolute;left:62%;bottom:0}.rear-hub .left2-center[data-v-30f378c9]{left:40%}.rear-hub .right2-center[data-v-30f378c9]{left:55%}", "", {"version":3,"sources":["/home/gitlab-runner/gitlab-runners/gitlab-ci-runner/builds/70a7f055/0/eagleeye/mybikesetup-web/mybikesetup/src/components/rim-display.vue"],"names":[],"mappings":"AACA,qBACE,UAAY,CACb,AACD,oBACE,gBAAiB,AACjB,eAAiB,CAClB,AACD,uDAEE,iBAAmB,CACpB,AACD,2BACE,kBAAmB,AACnB,QAAS,AACT,MAAQ,CACT,AACD,4BACE,kBAAmB,AACnB,QAAS,AACT,OAAS,CACV,AACD,+BACE,kBAAmB,AACnB,SAAU,AACV,QAAU,CACX,AACD,gCACE,kBAAmB,AACnB,SAAU,AACV,QAAU,CACX,AACD,yCACE,QAAU,CACX,AACD,0CACE,QAAU,CACX","file":"rim-display.vue","sourcesContent":["\nimg[data-v-30f378c9] {\n  width: 100%;\n}\nul[data-v-30f378c9] {\n  list-style: none;\n  text-align: left;\n}\n.rear-hub[data-v-30f378c9],\n.front-hub[data-v-30f378c9] {\n  position: relative;\n}\n.left-dia[data-v-30f378c9] {\n  position: absolute;\n  top: 35%;\n  left: 0;\n}\n.right-dia[data-v-30f378c9] {\n  position: absolute;\n  top: 35%;\n  right: 0;\n}\n.left2-center[data-v-30f378c9] {\n  position: absolute;\n  left: 44%;\n  bottom: 0;\n}\n.right2-center[data-v-30f378c9] {\n  position: absolute;\n  left: 62%;\n  bottom: 0;\n}\n.rear-hub .left2-center[data-v-30f378c9] {\n  left: 40%;\n}\n.rear-hub .right2-center[data-v-30f378c9] {\n  left: 55%;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 126:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.rim)?_c('div',[_c('h3',[_vm._v(" "+_vm._s(_vm.rim.manufacturer.name)+" - "+_vm._s(_vm.rim.model))]),_vm._v(" "),_c('ul',[(_vm.rim.diameter > 0)?_c('li',[_vm._v("Diameter: "+_vm._s(_vm.rim.diameter)+" mm")]):_vm._e(),_vm._v(" "),(_vm.rim.weight > 0)?_c('li',[_vm._v("Weight: "+_vm._s(_vm.rim.weight)+" g")]):_vm._e()])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 127:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base"},[_c('v-alert',{staticClass:"mb-4",attrs:{"value":"true","type":"info"}},[_vm._v("\n    Der Speichenrechner ist aktuell nur in einer Beta Version vorhanden, er rechnet richtig. Jedoch sind die Daten noch nicht vollständig gepflegt, wodurch es hier zu Fehlern kommen kann\n  ")]),_vm._v(" "),_c('v-layout',{attrs:{"wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-card',{staticClass:"calc-card",attrs:{"max-width":"400px"}},[_c('v-img',{staticClass:"white--text",attrs:{"height":"200px","gradient":"to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)","src":"/static/img/spoke/hub.JPG"}}),_vm._v(" "),_c('v-card-title',[_c('h2',[_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.spoke.hub_title')))])]),_vm._v(" "),_c('v-card-text',[_c('v-autocomplete',{attrs:{"label":_vm.$vuetify.t('$vuetify.spoke.hub_manufacturers_select'),"loading":_vm.hubLoading,"items":_vm.hubManufacturers,"return-json":"","item-text":"name","item-value":"id"},on:{"change":_vm.fetchHubs}}),_vm._v(" "),_c('v-autocomplete',{attrs:{"label":_vm.$vuetify.t('$vuetify.spoke.hub_select_title'),"items":_vm.hubs,"loading":_vm.calcLoading,"return-object":"","item-text":"model","item-value":"id"},on:{"change":_vm.calc},scopedSlots:_vm._u([{key:"item",fn:function(data){return [(data.item)?_c('p',[_vm._v("\n                "+_vm._s(data.item.model)+" ("+_vm._s(_vm.$vuetify.t(data.item.rear ? '$vuetify.spoke.hub_rear' : '$vuetify.spoke.hub_front'))+")\n              ")]):_vm._e()]}}]),model:{value:(_vm.selectedHub),callback:function ($$v) {_vm.selectedHub=$$v},expression:"selectedHub"}}),_vm._v(" "),_c('hub-display',{attrs:{"hub":_vm.selectedHub}})],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-card',{staticClass:"calc-card",attrs:{"max-width":"400px"}},[_c('v-img',{staticClass:"white--text",attrs:{"height":"200px","gradient":"to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)","src":"/static/img/spoke/rim.JPG"}}),_vm._v(" "),_c('v-card-title',[_c('h2',[_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.spoke.rim_title')))])]),_vm._v(" "),_c('v-card-text',[_c('v-autocomplete',{attrs:{"label":_vm.$vuetify.t('$vuetify.spoke.rim_manufacturers_select'),"loading":_vm.rimLoading,"items":_vm.rimManufacturers,"return-json":"","item-text":"name","item-value":"id"},on:{"change":_vm.fetchRims}}),_vm._v(" "),_c('v-autocomplete',{attrs:{"label":_vm.$vuetify.t('$vuetify.spoke.rim_select_title'),"items":_vm.rims,"loading":_vm.calcLoading,"return-object":"","item-text":"model","item-value":"id"},on:{"change":_vm.calc},scopedSlots:_vm._u([{key:"item",fn:function(data){return [(data.item)?_c('p',[_vm._v("\n                "+_vm._s(data.item.model)+" ("+_vm._s(_vm.$vuetify.t(data.item.rear ? '$vuetify.spoke.hub_rear' : '$vuetify.spoke.hub_front'))+")\n              ")]):_vm._e()]}}]),model:{value:(_vm.selectedRim),callback:function ($$v) {_vm.selectedRim=$$v},expression:"selectedRim"}}),_vm._v(" "),_c('rim-display',{attrs:{"rim":_vm.selectedRim}})],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-card',[_c('v-card-title',[_c('h2',[_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.spoke.result_title')))])]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"justify-center":"","wrap":""}},[_c('v-select',{staticClass:"small-element ma-3",attrs:{"label":_vm.$vuetify.t('$vuetify.spoke.spoke_count'),"items":[16,20,24,28,32,36,40]},model:{value:(_vm.spokeCount),callback:function ($$v) {_vm.spokeCount=$$v},expression:"spokeCount"}}),_vm._v(" "),_c('v-text-field',{staticClass:"small-element ma-3",attrs:{"label":_vm.$vuetify.t('$vuetify.spoke.spoke_crossing'),"type":"number"},model:{value:(_vm.spokeCrossing),callback:function ($$v) {_vm.spokeCrossing=$$v},expression:"spokeCrossing"}})],1),_vm._v(" "),_c('div',{staticClass:"result-container"},[_c('div',{staticClass:"result-element"},[_c('h4',[_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.spoke.spoke_length_left')))]),_vm._v(" "),_c('div',[_vm._v("\n              "+_vm._s(_vm.resultSpokeLeft)+" mm"),_c('br'),_vm._v(" "),_c('span',{staticClass:"mmmm"},[_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.spoke.exact')))])]),_vm._v(" "),_c('div',[_vm._v("\n              "+_vm._s(_vm.resultSpokeLeftRounded)+" mm"),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.spoke.recommended')))])])]),_vm._v(" "),_c('div',{staticClass:"result-element"},[_c('h4',[_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.spoke.spoke_length_left')))]),_vm._v(" "),_c('div',[_vm._v("\n              "+_vm._s(_vm.resultSpokeRight)+" mm"),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.spoke.exact')))])]),_vm._v(" "),_c('div',[_vm._v("\n              "+_vm._s(_vm.resultSpokeRightRounded)+" mm"),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.spoke.recommended')))])])])])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 84:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpokeCalculator_vue__ = __webpack_require__(94);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c9c19100_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpokeCalculator_vue__ = __webpack_require__(127);
function injectStyle (ssrContext) {
  __webpack_require__(117)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c9c19100"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpokeCalculator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c9c19100_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpokeCalculator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 94:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_StringMixin__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_hub_display__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_rim_display__ = __webpack_require__(123);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_StringMixin__["a" /* default */]],
  name: 'SpokeCalculator',
  components: { HubDisplay: __WEBPACK_IMPORTED_MODULE_2__components_hub_display__["a" /* default */], RimDisplay: __WEBPACK_IMPORTED_MODULE_3__components_rim_display__["a" /* default */] },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_1__main__["eventBus"].$emit('title-change', this.$vuetify.t('$vuetify.spoke.title'));

    this.fetchData();
  },
  data: function data() {
    return {
      rimLoading: false,
      hubLoading: false,
      calcLoading: false,
      resultSpokeLeft: '--',
      resultSpokeRight: '--',
      resultSpokeLeftRounded: '--',
      resultSpokeRightRounded: '--',
      hubManufacturers: [],
      hubs: [],
      rimManufacturers: [],
      rims: [],
      selectedHub: null,
      selectedRim: null,
      spokeCount: 32,
      spokeCrossing: 3
    };
  },

  methods: {
    fetchData: function fetchData() {
      var _this = this;

      fetch('https://wsf-be.die-gestalten.net/mybikesetup/wheels/hubs/manufacturers').then(function (response) {
        return response.ok ? response.json() : alert('mist');
      }).then(function (json) {
        _this.hubManufacturers = json.manufacturers;
        // this.hubs = json.hubs;
      });
      fetch('https://wsf-be.die-gestalten.net/mybikesetup/wheels/rims/manufacturers').then(function (response) {
        return response.ok ? response.json() : alert('mist');
      }).then(function (json) {
        _this.rimManufacturers = json.manufacturers;
        // this.rims = json.rims;
      });
    },
    fetchHubs: function fetchHubs(manuId) {
      var _this2 = this;

      this.hubLoading = true;
      fetch('https://wsf-be.die-gestalten.net/mybikesetup/wheels/hubs/manufacturers/' + manuId).then(function (response) {
        return response.ok ? response.json() : alert('mist');
      }).then(function (json) {
        _this2.hubs = json.hubs;
        _this2.hubLoading = false;
      });
    },
    fetchRims: function fetchRims(manuId) {
      var _this3 = this;

      this.rimLoading = true;
      fetch('https://wsf-be.die-gestalten.net/mybikesetup/wheels/rims/manufacturers/' + manuId).then(function (response) {
        return response.ok ? response.json() : alert('mist');
      }).then(function (json) {
        _this3.rims = json.rims;
        _this3.rimLoading = false;
      });
    },
    calc: function calc() {
      var _this4 = this;

      this.resultSpokeLeft = '--';
      this.resultSpokeRight = '--';
      this.resultSpokeLeftRounded = '--';
      this.resultSpokeRightRounded = '--';
      if (this.selectedHub != null && this.selectedRim != null) {
        this.calcLoading = true;
        fetch('https://wsf-be.die-gestalten.net/mybikesetup/wheels/calc/hub/' + this.selectedHub.id + '/rim/' + this.selectedRim.id + '?spokeCount=' + this.spokeCount + '&spokeCrossing=' + this.spokeCrossing).then(function (response) {
          return response.ok ? response.json() : alert('mist');
        }).then(function (json) {
          _this4.calcLoading = false;
          if (json.success) {
            _this4.resultSpokeLeft = json.result.spokeLengthLeft.toFixed(1);
            _this4.resultSpokeRight = json.result.spokeLengthRight.toFixed(1);
            _this4.resultSpokeLeftRounded = json.result.spokeLengthLeftRounded;
            _this4.resultSpokeRightRounded = json.result.spokeLengthRightRounded;
          }
        });
      }
    }
  }
});

/***/ }),

/***/ 95:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hub-display',
  props: ['hub']
});

/***/ }),

/***/ 96:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'rim-display',
  props: ['rim']
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/0.e445bae9bd97d94bb395.js